export const ACTIVATION_BEGIN = 'ACTIVATION_BEGIN';
export const ACTIVATION_CLEAR = 'ACTIVATION_CLEAR';
export const ACTIVATION_FAILURE = 'ACTIVATION_FAILURE';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const LOGIN_BEGIN = 'LOGIN_BEGIN';
export const LOGIN_CLEAR = 'LOGIN_CLEAR';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT = 'LOGOUT';
export const PASSWORD_EMAIL_BEGIN = 'PASSWORD_EMAIL_BEGIN';
export const PASSWORD_EMAIL_CLEAR = 'PASSWORD_EMAIL_CLEAR';
export const PASSWORD_EMAIL_FAILURE = 'PASSWORD_EMAIL_FAILURE';
export const PASSWORD_EMAIL_SUCCESS = 'PASSWORD_EMAIL_SUCCESS';
export const PASSWORD_RESET_BEGIN = 'PASSWORD_RESET_BEGIN';
export const PASSWORD_RESET_CLEAR = 'PASSWORD_RESET_CLEAR';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const REGISTRATION_BEGIN = 'REGISTRATION_BEGIN';
export const REGISTRATION_CLEAR = 'REGISTRATION_CLEAR';
export const REGISTRATION_FAILURE = 'REGISTRATION_FAILURE';
export const REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
export const SET_TOKEN = 'SET_TOKEN';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';

export const WHO_AMI = 'WHO_AMI';
export const WHO_AMI_DELETE = 'WHO_AMI_DELETE';

export const LOGIN_MENU_OPENED = 'LOGIN_MENU_OPENED';
export const PASSWORD_CHANGE_FAILURE = 'PASSWORD_CHANGE_FAILURE';
export const PASSWORD_CHANGE_REINIT = 'PASSWORD_CHANGE_REINIT';

export const SHOW_GET_PDF = 'SHOW_GET_PDF';
export const HIDE_GET_PDF = 'HIDE_GET_PDF';

export const SHOW_PREVIEW_CV = 'SHOW_PREVIEW_CV';
export const HIDE_PREVIEW_CV = 'HIDE_PREVIEW_CV';

export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';
export const CLOSE_DRAWER = 'CLOSE_DRAWER';

export const TOGGLE_DRAWER_LANDING = 'TOGGLE_DRAWER';
export const CLOSE_DRAWER_LANDING = 'CLOSE_DRAWER';

export const MODEL_OBJECT = 'MODEL_OBJECT';
export const MODEL_OBJECT_2 = 'MODEL_OBJECT_2';

export const LOADING_REINIT = 'LOADING_REINIT';
export const LOADING_ADDELEM = 'LOADING_ADDELEM';

export const CV_MODEL_UPDATE = 'CV_MODEL_UPDATE';
export const CV_MODEL_UPDATE_2 = 'CV_MODEL_UPDATE_2';
export const CV_MODEL_UPDATE_COLOR = 'CV_MODEL_UPDATE_COLOR';
export const CV_MODEL_UPDATE_FONT = 'CV_MODEL_UPDATE_FONT';
